import { PokerShow } from '@/models/games/PokerShow';
import {
    SupportedGameResult,
    SupportedGameState,
    SupportedGoodRoad,
} from '@/modules/host/models';

export type SupportedGameLiveData = {
    HostId: number;
    CurrentResult?: SupportedGameResult;
    CurrentState: SupportedGameState;
    PokerShowResult?: Array<PokerShow>;
    GoodRoad?: SupportedGoodRoad;
    IsGoodRoad: boolean;
    ResultReleased: boolean;

    CountDown: number;
    RemainTime: number;
    PendingTime?: number;
    CanLeave?: boolean;
    ShuffleTimer?: NodeJS.Timeout;
};

export type HostTableLive = SupportedGameLiveData;
export const initialLHostTable = {} as HostTableLive;
